export const formatUtcDateTime = (ms: number | undefined): string => {
    if (!ms) return "—";
    return new Date(ms).toISOString();
};

export const fmtVal = (rule: unknown): string => {
    if (!rule) return "—";
    const r = rule as Record<string, unknown>;
    if (r.type === "range") return `${r.min} to ${r.max}`;
    return (r.value as string) ?? "—";
};

// Keep floating menu coordinates constrained to the viewport bounds.
export const clampMenuPosition = (
    top: number,
    left: number,
    menuWidth: number,
    menuHeight: number,
    viewportWidth: number,
    viewportHeight: number,
    margin: number,
): { top: number; left: number } => {
    const maxLeft = viewportWidth - menuWidth - margin;
    const maxTop = viewportHeight - menuHeight - margin;
    return {
        left: Math.min(Math.max(left, margin), Math.max(margin, maxLeft)),
        top: Math.min(Math.max(top, margin), Math.max(margin, maxTop)),
    };
};

// Parse persisted scrollTop safely from session storage values.
export const parseStoredScrollTop = (value: string | null): number | null => {
    if (value === null) return null;
    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
};

export const FILTER_OPERATOR = {
  enabledSearch: false,
  multiselection: false,
  placeholder: 'Operator',
  options: [
    { label: '= Equals', value: '= Equals' },
    { label: '≠ not Equals', value: '≠ not Equals' },
  ],
};

export const normalizeFilterValue = (value?: string | null) => {
  const trimmed = value?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : '—';
};

export const buildFilterOptions = (values: Array<string | undefined | null>) => {
  const unique = Array.from(new Set(values.map(normalizeFilterValue)));
  return unique.sort().map((value) => ({ label: value, value }));
};

export const buildFilterItem = (label: string, options: { label: string; value: string }[]) => ({
  label,
  value: label,
  operator: FILTER_OPERATOR,
  properties: { enabledSearch: true, multiselection: true, placeholder: 'Value', options },
});

/** Decodes a base64 string and triggers a file download in the browser */
export const downloadBase64File = (base64: string, type: string, name: string): void => {
  const cleanedBase64 = base64.replace(/\s/g, "");
  const byteCharacters = atob(cleanedBase64);
  const byteArrays: Uint8Array<ArrayBuffer>[] = [];
  for (let i = 0; i < byteCharacters.length; i += 512) {
    const slice = byteCharacters.slice(i, i + 512);
    const byteNumbers = new Array(slice.length);
    for (let j = 0; j < slice.length; j++) byteNumbers[j] = slice.charCodeAt(j);
    byteArrays.push(new Uint8Array(byteNumbers));
  }
  const blob = new Blob(byteArrays as any, { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};